import React, { useState } from "react";
import { Button, Form, Input, message, Modal, Radio } from "antd";
import "./index.css";
import { inviteMember, updateMember } from "../APIs/firebaseMemberSettingApi";
import { assignPropertyIfMemberExist } from "../../Auth/APIs/authApis";

const { Group } = Radio;

const MemberForm = (props) => {
  const {
    showModal,
    hideModal,
    selectedProperty,
    properties,
    members,
    setMembers,
    setLoading,
    modalData,
    roles,
    user,
    loading,
  } = props;
  const [formLoading, setFormLoading] = useState(false);

  const handleAdd = async (values) => {
    if (members.find((row) => row.email === values.email && row.invited)) {
      message.warning("Member already invited");
      hideModal();
      return;
    }
    if (members.find((row) => row.email === values.email)) {
      message.info("Member already exists.");
      hideModal();
      return;
    }

    const property = properties.find((row) => row.id === selectedProperty);
    const role = roles.find((row) => row.slug === values.role);
    const invite = values?.add_type === "send-invite" ? true : false;

    const obj = {
      ...values,
      role,
      invitedBy: user.name,
      invitedById: user.id,
      propertyId: selectedProperty,
      propertyName: property.name,
      sendEmail: invite,
    };

    setFormLoading(true);
    const response = await inviteMember(obj);

    if (response) {
      if (!invite) {
        const result = await assignPropertyIfMemberExist(
          values?.email,
          selectedProperty,
          true
        ).finally(() => {
          setFormLoading(false);
        });
        hideModal();
        setMembers({ ...obj, id: response, invited: invite });
        message.info("Member Added");
      } else {
        hideModal();
        setMembers({ ...obj, id: response, invited: invite });
        message.info("Member invited");
      }
    }
  };

  const handleEdit = async (values) => {
    setFormLoading(true);
    const role = roles.find((row) => row.slug === values.role);
    const data = {
      ...values,
      id: modalData.id,
      name: modalData.name,
      invitedBy: modalData.invitedBy,
      role,
      propertyId: selectedProperty,
    };
    const response = await updateMember(data).finally(() => {
      setFormLoading(false);
    });
    hideModal();
    setMembers({ ...data, id: response });
    message.info("role updated");
  };

  return (
    <Modal closable={false} centered open={showModal} footer={null}>
      <Form
        name="member"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        onFinish={modalData?.id ? handleEdit : handleAdd}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="Email"
          initialValue={modalData?.email}
          rules={[
            {
              required: true,
              message: "Email is Required",
            },
            {
              type: "email",
              message: "Invalid email",
            },
          ]}
        >
          <Input disabled={modalData?.id} />
        </Form.Item>
        <Form.Item
          initialValue={modalData?.role?.slug}
          name="role"
          label="Role"
          rules={[
            {
              required: true,
              message: "Role is Required",
            },
          ]}
        >
          <Group>
            {roles.map((role) => (
              <Radio key={role.slug} value={role.slug}>
                {role.name}
              </Radio>
            ))}
          </Group>
        </Form.Item>

        {!modalData?.id && (
          <Form.Item
            initialValue="send-invite"
            name="add_type"
            label="Add Member by"
            rules={[
              {
                required: true,
                message: "This field is required",
              },
            ]}
          >
            <Group>
              <Radio value="send-invite">Send Invite</Radio>
              <Radio value="add-forcefully">Add Forcefully</Radio>
            </Group>
          </Form.Item>
        )}

        <Form.Item style={{ textAlign: "end" }}>
          <Button onClick={() => hideModal()}>Cancel</Button>
          <Button
            htmlType="submit"
            className="ml-2 submit_Btn"
            disabled={formLoading}
            loading={formLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(MemberForm);
